import { FC, useState } from "react";
import { EBtnType } from "@/models/common/enums";
import { MDBRow } from "mdb-react-ui-kit";
import Btn from "@/components/common/Btn";
import { useStore } from "@/store/index";
import InputFile from "../InputFile";

const UploadAvatarModalBody: FC<{
    onSuccessAfterUpload: () => void;
}> = ({ onSuccessAfterUpload }) => {
    const [file, setFile] = useState<File>();

    const uploadUserAvatar = useStore(state => state.uploadUserAvatar);

    return (
        <MDBRow className="g-0 py-2">
            <InputFile
                onChageFile={f => {
                    setFile(f);
                }}
            />
            <Btn
                btnType={EBtnType.PRIMARY}
                onClick={() => uploadUserAvatar(file, onSuccessAfterUpload)}
                fullWith
                className="mt-4"
                disabled={!file}
            >
                Upload
            </Btn>
        </MDBRow>
    );
};

export default UploadAvatarModalBody;
